(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  $('.hero').each(function() {
    var $hero = $(this);
    var sectionId = $hero.data('section-id');
    var $dotsContainer = $('.slick-dots-container-' + sectionId);
    var slideCount = $hero.find('.hero-slick').length;
    var showDots = slideCount > 1;
    
    $hero.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: showDots,
      arrows: false,
      appendDots: $dotsContainer,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: showDots,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
// Find the product recommendations container
  const recommendationsContainer = document.querySelector('.product-recommendations');
  
  if (recommendationsContainer) {
    // Function to load the Judge.me badges
    const loadJudgeMeReviews = () => {
      // Check if the Judge.me script object exists and has the load_badges function
      if (typeof JDGM !== 'undefined' && typeof JDGM.load_badges === 'function') {
        // Manually trigger Judge.me to scan the new content for review badges
        JDGM.load_badges();
        console.log('Judge.me review badges reloaded for product recommendations.');
      } else {
        console.warn('Judge.me global object (JDGM) not found. Review badges may not load.');
      }
    };
    
    // Use a short delay to ensure the included product cards are fully rendered
    // before calling the Judge.me script.
    setTimeout(loadJudgeMeReviews, 500);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-navigation"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const mobileNavDrawer = document.getElementById('mobileNavDrawer');
    const mobileNavClose = document.getElementById('mobileNavClose');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const navToggles = document.querySelectorAll('.mobile-nav-item__toggle');
    const hamburgerIcon = mobileMenuToggle ? mobileMenuToggle.querySelector('.navbar-toggler-icon') : null;

    // Open mobile nav
    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener('click', function() {
        const isOpen = mobileNavDrawer.classList.contains('active');
        
        if (isOpen) {
          // Close the menu
          closeMobileNav();
        } else {
          // Open the menu
          mobileNavDrawer.classList.add('active');
          document.body.style.overflow = 'hidden';
          if (hamburgerIcon) {
            hamburgerIcon.classList.add('open');
          }
        }
      });
    }

    // Close mobile nav
    function closeMobileNav() {
      mobileNavDrawer.classList.remove('active');
      document.body.style.overflow = '';
      if (hamburgerIcon) {
        hamburgerIcon.classList.remove('open');
      }
    }

    if (mobileNavClose) {
      mobileNavClose.addEventListener('click', closeMobileNav);
    }

    if (mobileNavOverlay) {
      mobileNavOverlay.addEventListener('click', closeMobileNav);
    }

    // Accordion functionality
    navToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');
        const targetContent = document.getElementById(targetId);
        const isActive = this.classList.contains('active');

        // Close all other accordions
        navToggles.forEach(function(otherToggle) {
          if (otherToggle !== toggle) {
            otherToggle.classList.remove('active');
            const otherId = otherToggle.getAttribute('data-target');
            const otherContent = document.getElementById(otherId);
            if (otherContent) {
              otherContent.classList.remove('active');
            }
          }
        });

        // Toggle current accordion
        if (isActive) {
          this.classList.remove('active');
          targetContent.classList.remove('active');
        } else {
          this.classList.add('active');
          targetContent.classList.add('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
